    const dfLayerOptions = {
    installationId: '640f920b-58fd-49c2-af05-6b33d87c649a',
    zone: 'eu1'
};

    (function (l, a, y, e, r, s) {
    r = l.createElement(a); r.onload = e; r.async = 1; r.src = y;
    s = l.getElementsByTagName(a)[0]; s.parentNode.insertBefore(r, s);
})(document, 'script', 'https://cdn.doofinder.com/livelayer/1/js/loader.min.js', function () {
    doofinderLoader.load(dfLayerOptions);
});

// import app from "../_app";
// import axios from "axios";
//
// const search = document.querySelector('.js-search');
//
// if(search) {
//     const input = search.querySelector('.js-search-input');
//     const resultTypes = [...document.querySelectorAll('.js-search-result-type')];
//     const showAll = search.querySelector('.js-search-show-all');
//     const showAllLink = search.querySelector('.js-search-show-all-link');
//     const resultsNone = search.querySelector('.js-search-results-none');
//     const resultsNoneTerm = search.querySelector('.js-search-results-none-term');
//
//     const triggers = [...document.querySelectorAll('.js-search-trigger')];
//
//     const triggerClickHandler = () => {
//         if(search.hasAttribute('data-open')) {
//             search.removeAttribute('data-open');
//             input.value = '';
//             input.dispatchEvent(new Event('input'));
//
//             app.unlockBody();
//         } else {
//             app.lockBody();
//
//             search.setAttribute('data-open', '');
//
//             setTimeout(() => {
//                 input.focus();
//             }, 300);
//         }
//     };
//
//     const resultBlueprint = (type, result) => (`
//         <a href="${result.url}" class="search__result">
//             ${type === 'products' ? `
//                 <picture class="search__result-image img bg--w">
//                     <source media="(max-width: 991px)" srcset="${app.image(result.image, 80, 80)} 1x, ${app.image(result.image, 160, 160)} 2x" />
//                     <source media="(min-width: 992px)" srcset="${app.image(result.image, 80, 80)} 1x, ${app.image(result.image, 160, 160)} 2x" />
//
//                     <img src="${app.image(result.image, 80, 80)}" width="80" height="80" />
//                 </picture>
//             ` : ''}
//
//             <div>
//                 <p>${result.title}</p>
//
//                 ${type === 'products' ? `
//                     <p class="search__result-price price mt-2">
//                         <span class="fs-500 fw-700">${app.currency(result.price)}</span>
//
//                         ${+result.compare_at_price_min !== 0 ? `
//                             <span class="fs-300 fw-700 c--500 ms-1">${app.currency(result.compare_at_price_min)}</span>
//                         ` : ''}
//                     </p>
//                 ` : ''}
//             </div>
//         </a>
//     `);
//
//     const inputInputHandler = async (e) => {
//         e.preventDefault();
//
//         const term = e.currentTarget.value;
//
//         if(term.length > 0) {
//
//             try {
//                 const {data} = await axios.get(`${window.Shopify.routes.root}search/suggest.json?q=${term}&resources[options][fields]=body,product_type,tag,title,variants.barcode,variants.sku,variants.title,vendor`);
//                 let hasResults = false;
//
//                 if(input.value.length > 0) {
//                     resultTypes.map((resultType) => {
//                         if(data?.resources?.results?.[resultType.dataset.type].length > 0) {
//                             hasResults = true;
//
//                             resultType.innerHTML = '';
//
//                             data?.resources?.results?.[resultType.dataset.type].map((result) => {
//                                 resultType.innerHTML += resultBlueprint(resultType.dataset.type, result);
//                             });
//
//                             resultType.removeAttribute('data-hidden');
//                         } else {
//                             resultType.setAttribute('data-hidden', '');
//                         }
//                     });
//
//                     if(!hasResults) {
//                         showAll.setAttribute('data-hidden', '');
//                         resultsNoneTerm.innerText = term;
//                         resultsNone.removeAttribute('data-hidden');
//                     } else {
//                         showAllLink.setAttribute('href', `${window.Shopify.routes.root}search?type=product,page&q=${term}`);
//                         showAll.removeAttribute('data-hidden');
//                         resultsNone.setAttribute('data-hidden', '');
//                     }
//                 }
//             } catch (e) {
//                 console.log(e)
//             }
//         } else {
//             resultTypes.map((resultType) => resultType.setAttribute('data-hidden', ''));
//             showAll.setAttribute('data-hidden', '');
//             resultsNone.setAttribute('data-hidden', '');
//         }
//     }
//
//     const inputEnterHandler = (e) => {
//         if(e.keyCode === 13) {
//             window.location.href = `${window.Shopify.routes.root}search?type=product,page&q=${input.value}`;
//         }
//     }
//
//     input.addEventListener('input', inputInputHandler);
//     input.addEventListener('keyup', inputEnterHandler);
//     triggers.map(trigger => trigger.addEventListener('click', triggerClickHandler));
// }
